<template>
  <div>
    <div id="billingMethods">
      <h1>Create New Billing Method</h1>
      <div class="addMethodContainer">
        <label for="card">Credit or Debit Card</label>
        <div ref="card" class="card-style" />
      </div>
      <div class="center-text">
        <button
          tag="button"
          name="addCard"
          class="button button-200"
          @click="saveCard"
        >
          Save Credit Card
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/index";
const apiServiceBilling = new api.APIServiceBilling();

let stripe = window.Stripe("pk_test_JXV2FSohmFkHq35z1W9AGytx");
let elements = stripe.elements();
let card = elements.create("card");

export default {
  name: "AccountBillingCreate",
  mounted: function() {
    var cardStyle = {
      base: {
        fontSize: "20px",
        lineHeight: "28px"
      }
    };
    card.mount(this.$refs.card, { cardStyle });
  },
  methods: {
    saveCard: function() {
      stripe.createSource(card).then(result => {
        // console.log(result);
        // update the api
        let cardAccount = {
          payment_method: result.source.card.brand,
          payment_exp_date:
            result.source.card.exp_month + "/" + result.source.card.exp_year,
          payment_last_4: result.source.card.last4,
          stripe_source_id: result.source.id
        };
        // console.log(cardAccount);
        // this.$store.dispatch('createAccountBillingMethod', cardAccount).then(() => {
        //   this.$router.push('/console/dashboard/account/billing');
        // });
        apiServiceBilling.createAccountBillingMethod(cardAccount).then(() => {
          this.$router.push("/console/account/billing");
        });
      });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 18px;
}
h3 {
  font-size: 18px;
  margin-bottom: 0;
}
#billingMethods {
  lost-utility: clearfix;
}
.billingMethods {
  width: 100%;
  lost-column: 1/1;
}
.billingMethod {
  lost-column: 1/3;
  background: #d5e3f4;
  padding: 15px;
  border-radius: 4px;
  lost-utility: clearfix;
  margin-bottom: 20px;
}
.addMethodContainer {
  margin-top: 15px;
}
@media (max-width: 800px) {
  .billingMethod {
    lost-column: 1/2;
  }
}
@media (max-width: 640px) {
  .billingMethod {
    lost-column: 1/1;
  }
}
.card-style {
  border: 1px solid #ccc;
  height: 40px;
  width: 70%;
  border-radius: 4px;
}
</style>
